'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { isBlock } from '../../dom/index.js';
import { DEFAULT_BLOCK_ELEMENT } from '../../dom/parseBlockAttributes.js';
import { useBlock } from './hooks/index.js';
import { useBlockAttributes } from './hooks/useBlockAttributes.js';
export function CoverBlock({ domNode: node = DEFAULT_BLOCK_ELEMENT, children, component: Component, style, }) {
    const { name, className, attributes } = useBlock(node);
    const blockAttributes = useBlockAttributes(node);
    return (_jsx(Component, { name: name, domNode: node, className: className, overlayColor: attributes.overlayColor, id: attributes.id, dimRatio: attributes.dimRatio, isDark: attributes.isDark, url: attributes.url, minHeight: attributes.minHeight, hasParallax: !!attributes.hasParallax, isRepeated: !!attributes.isRepeated, focalPoint: attributes.focalPoint, attributes: blockAttributes, style: style, children: children }));
}
/**
 * @internal
 */
// eslint-disable-next-line no-redeclare
(function (CoverBlock) {
    CoverBlock.defaultProps = {
        test: (node) => isBlock(node, { tagName: 'div', className: 'wp-block-cover' }),
        /**
         * Exclude all direct children except the paragraph inner block
         *
         * @param node The dom node
         * @returns
         */
        exclude: (node) => {
            var _a;
            const isDirectChild = ((_a = node === null || node === void 0 ? void 0 : node.parent) === null || _a === void 0 ? void 0 : _a.attribs) &&
                node.parent.attribs.class.split(' ').includes('wp-block-cover');
            return (isDirectChild &&
                !node.attribs.class.split(' ').includes('wp-block-cover__inner-container'));
        },
    };
})(CoverBlock || (CoverBlock = {}));
